import React from "react";

import PropTypes from "prop-types";

import { toTOACodeOptions } from "components/flowable/ClassificationCodes/helpers";
import CodeTemplate from "components/flowable/ClassificationCodes/internal/CodeTemplate";
import { useDictionary } from "hooks";


const TOACode = ({ toaMinimum, toaMaximum, ...rest }) => {
	const dictionary = useDictionary("classificationCodes.toa");

	return (
		<CodeTemplate
			codeType="toa"
			toCodeOptions={toTOACodeOptions}
			dictionary={dictionary}
			maximumNumberOfCodes={toaMaximum}
			minimumNumberOfCodes={toaMinimum}
			{...rest}
		/>
	);};

TOACode.defaultProps = {
	toaMinimum: 1,
	toaMaximum: 4,
	includePercentage: true,
};

TOACode.propTypes = {
	toaMinimum: PropTypes.number,
	toaMaximum: PropTypes.number,
	includePercentage: PropTypes.bool,
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	enabled: PropTypes.bool.isRequired,
};

export default TOACode;
